export default __webpack_public_path__ + "static/media/books-39.799b7559.jpg";